<template>
  <div class="btn-nav">
    <img src="../assets/images/belbouk.svg" alt="logo" />
    <button ref="btnNav" @click="showMenu">
      <span class="navba-toggler-icon"></span>
    </button>
  </div>
  <div ref="menu" class="side">
    <div class="infos">
      <img src="../assets/images/avatar.png" class="avatar" alt="avatar" />
      <h1>BELBOUK Ayyoub</h1>
      <h3>Full Stack Web Developer</h3>

      <p class="dnm icons">
        <a href="https://web.facebook.com/belbouk.ayyoub/" target="NEW">
          <svg width="25" height="25">
            <use xlink:href="#facebook" />
          </svg>
        </a>
        <a href="https://www.linkedin.com/in/belbouk-ayyoub/" target="NEW">
          <svg width="25" height="25">
            <use xlink:href="#linkedin" />
          </svg>
        </a>
        <a href="https://wa.me/212606196345" target="NEW">
          <svg width="25" height="25">
            <use xlink:href="#whatsapp" />
          </svg>
        </a>
        <a href="https://t.me/Belbouk" target="NEW">
          <svg width="25" height="25">
            <use xlink:href="#telegram" />
          </svg>
        </a>
      </p>

      <img class="dnm" src="../assets/images/belbouk.svg" alt="logo" />
    </div>

    <div class="nav">
      <router-link to="/">
        <svg class="bi" width="50" height="50">
          <use xlink:href="#belbouk" />
        </svg>
        <span class="text-link">Home</span>
      </router-link>

      <router-link to="/about-me">
        <svg class="bi" width="50" height="50">
          <use xlink:href="#user" />
        </svg>
        <span class="text-link">About Me</span>
      </router-link>

      <router-link to="/resume">
        <svg class="bi" width="50" height="50">
          <use xlink:href="#graduation" />
        </svg>
        <span class="text-link">Resume</span>
      </router-link>

      <router-link to="/protfolio">
        <svg class="bi" width="50" height="50">
          <use xlink:href="#briefcase" />
        </svg>
        <span class="text-link">Portfolio</span>
      </router-link>

      <router-link to="/contact">
        <svg class="bi" width="50" height="50">
          <use xlink:href="#envelope" />
        </svg>
        <span class="text-link">Contact</span>
      </router-link>

      <a href="/belbouk-resume.pdf" target="_new">
        <svg class="bi" width="50" height="50">
          <use xlink:href="#download" />
        </svg>
        <span class="text-link">Get CV</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  data() {
    return {
      menuShowed: false,
    };
  },

  watch: {
    menuShowed: function (v) {
      if (v) {
        this.$refs.menu.classList.add("show");
      } else {
        this.$refs.menu.classList.remove("show");
      }
    },
    $route: function () {
      this.menuShowed = false;
      console.log("route", this.menuShowed);
    },
  },
  methods: {
    showMenu() {
      this.menuShowed = !this.menuShowed;
      console.log(this.menuShowed);
    },
  },
};
</script>

<style lang="scss">
.infos {
  .icons {
    display: flex;
    justify-content: center;
    gap: 10px;
    svg {
      fill: #fff;
    }
    a:hover {
      transform: scale(1.2);
      svg {
        fill: #fdae57;
      }
    }
  }
}
</style>
